export const ItemTypes = {
    OPERATOR: 'opt',
    VARIABLE: 'variable',
    CUSTOM: 'custom'
}
  